<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0769 9.5L16.9497 6.35333C17.0358 6.2835 17.1454 6.23595 17.2647 6.21669C17.384 6.19743 17.5077 6.20733 17.62 6.24514C17.7324 6.28295 17.8285 6.34697 17.8961 6.42911C17.9637 6.51126 17.9999 6.60784 18 6.70667V14.2933C17.9999 14.3922 17.9637 14.4887 17.8961 14.5709C17.8285 14.653 17.7324 14.717 17.62 14.7549C17.5077 14.7927 17.384 14.8026 17.2647 14.7833C17.1454 14.7641 17.0358 14.7165 16.9497 14.6467L13.0769 11.5M13.0769 11.5V7.5C13.0769 7.10218 12.8824 6.72064 12.5362 6.43934C12.19 6.15804 11.7204 6 11.2308 6L3.61256 6.01205C3.20908 6.05386 2.83142 6.20315 2.54073 6.43934C2.1945 6.72064 2 7.10218 2 7.5V13.5C2 13.8978 2.1945 14.2794 2.54073 14.5607C2.88695 14.842 3.35652 15 3.84615 15H11.2308C11.7204 15 12.19 14.842 12.5362 14.5607M13.0769 11.5L13.077 13.5C13.077 13.8978 12.8824 14.2794 12.5362 14.5607M12.5362 14.5607C12.5713 14.5322 12.6048 14.5026 12.6367 14.4722"
      stroke="#747474"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
